export const ADD_NOTIFICATION = 'ADD_NOTIFICATION';
export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION';

export const addNotificationAction = ({ message, variant }) => {
  return {
    type: ADD_NOTIFICATION,
    payload: {
      id: new Date().getTime(),
      message,
      variant,
    },
  };
};

export const removeNotificationAction = id => {
  return {
    type: REMOVE_NOTIFICATION,
    payload: id,
  };
};
